import { METAFY_PRO_ID } from '$lib/constants';
import type { Api_Order } from '$lib/types/api/graphql';
import { analytics } from '$lib/utils';

const getProductsData = (order_id: Pick<Api_Order, 'id'>, orderInfo: Api_Order) => {
  const products = orderInfo.items.map(o => {
    return {
      item_id: METAFY_PRO_ID, // hard-coded as the data from API is not the static product id
      item_category: o.product.productType,
      item_name: o.product.name,
      affiliation: o.product.seller?.slug,
      price: o.total
    };
  });
  return {
    transaction_id: order_id,
    value: orderInfo.totalDue,
    currency: 'USD',
    items: products
  };
};

export const trackCheckoutStarted = (order_id: Pick<Api_Order, 'id'>, orderInfo: Api_Order | Record<string, any>) => {
  const productData = getProductsData(order_id, orderInfo as Api_Order);
  analytics.track({
    name: 'Checkout Started',
    props: productData
  });
};

export const trackOrderCompleted = (order_id: Pick<Api_Order, 'id'>, orderInfo: Api_Order | Record<string, any>) => {
  const productData = getProductsData(order_id, orderInfo as Api_Order);
  analytics.track({
    name: 'Order Completed',
    props: productData
  });
};
